var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDumbbell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-dumbbell",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 14.4 9.6 9.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.657 21.485a2 2 0 1 1-2.829-2.828l-1.767 1.768a2 2 0 1 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.829 2.829l-1.768 1.767a2 2 0 1 1 2.828 2.829z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m21.5 21.5-1.4-1.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 3.9 2.5 2.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.404 12.768a2 2 0 1 1-2.829-2.829l1.768-1.767a2 2 0 1 1-2.828-2.829l2.828-2.828a2 2 0 1 1 2.829 2.828l1.767-1.768a2 2 0 1 1 2.829 2.829z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDumbbell);
export default __webpack_public_path__ + "static/media/dumbbell.1dfa992215c96eb9cfa0299a7215e63e.svg";
export { ForwardRef as ReactComponent };